import * as requestOtp from './requestOtp'
import * as updatePassword from './updatePassword'
import * as verifyOtp from './verifyOtp'
export default {
    ...requestOtp,
    ...updatePassword,
    ...verifyOtp,
} 